'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineOverlayFooter = function InlineOverlayFooter(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'content-footer clearfix' },
    children
  );
};

InlineOverlayFooter.displayName = 'InlineOverlayFooter';
InlineOverlayFooter.propTypes = {
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
};

exports.default = InlineOverlayFooter;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-footer/components/InlineOverlayFooter.component.js
// module id = 1320
// module chunks = 1